<template>
  <nav class="navbar menu" v-if="isAuthenticated">
    <div class="logo-container">
      <div class="navbar__logo"></div>
    </div>

    <ul v-if="!isPlatformAdminRoute" class="nav-item-container menu-list">
      <NavBarMenuItem icon="comment-alt" path="/web-assistant" :selected-route-prefix="['web-assistant', 'root']" />
      <NavBarMenuItem icon="robot" :path="botsLandingPage" selected-route-prefix="bots" />
      <NavBarMenuItem icon="user-friends" path="/contacts" selected-route-prefix="contacts" />
      <NavBarMenuItem icon="chart-area" path="/reports/overview" selected-route-prefix="reports" />
      <NavBarMenuItem icon="cubes" path="/apps" selected-route-prefix="apps" />
      <NavBarMenuItem icon="code" path="/your-apps" selected-route-prefix="private-apps" />
    </ul>

    <ul v-else class="nav-item-container menu-list">
      <NavBarMenuItem
        icon="warehouse"
        path="/platform-admin/workspaces"
        selected-route-prefix="platform-admin-workspace"
      />
      <NavBarMenuItem icon="users-gear" path="/platform-admin/users" selected-route-prefix="platform-admin-users" />
    </ul>

    <SettingsNavMenu />
  </nav>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { ATTENDANT_TRIAGE_FLOWS_ENABLED } from '@/store/app/featureTypes';
import { useAuth } from '@/authentication/useAuth';
import NavBarMenuItem from '@shared/components/navbar/NavBarMenuItem.vue';
import SettingsNavMenu from '@shared/components/navbar/SettingsNavMenu.vue';
import { useRoute } from 'vue-router';

// Vuex store
const store = useStore();

const { isAuthenticated } = useAuth();

// Computed properties (Vuex getters)
const isWorkspaceFeatureEnabled = computed(() => store.getters.isWorkspaceFeatureEnabled);
const botsLandingPage = computed(() =>
  isWorkspaceFeatureEnabled.value(ATTENDANT_TRIAGE_FLOWS_ENABLED, true) ? '/bots/tasks' : '/bots/flows',
);

const route = useRoute();
const activeRouteName = computed(() => String(route?.name || ''));
const isPlatformAdminRoute = computed(() => activeRouteName.value.startsWith('platform-admin'));
</script>
